export default __webpack_public_path__ + "locales/sl/JavascriptSdk.json?hash=47b2f0ce5181917f48a67ff177e174a8";